import { MatDialogConfig } from '@angular/material/dialog';
import { RMA_MAT_DIALOG_DEFAULT_OPTIONS } from '../util-rma-material-module/util-rma-material-module';

export const applyWithDialogDefaults = (config: MatDialogConfig): MatDialogConfig => {
  return {
    ...RMA_MAT_DIALOG_DEFAULT_OPTIONS,
    ...config,
  };
};
